import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import UserHome from './home/home';
import UserDetail from './components/detail';
import './user.css';


export default class User extends Component {
  render() {
    return (
      <Switch>
        <Route path="/admin/test" component={UserHome} exact></Route>
        <Route path="/admin/test/test" component={UserDetail}></Route>
        <Redirect to="/admin/test"></Redirect>
      </Switch>
    );
  }
}
